/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TclItsmUserActionmapping {
    getFixupPrototypeFunction() { return TclItsmUserActionmapping.fixupPrototype; }

    static newInstance(model: Partial<TclItsmUserActionmapping>): TclItsmUserActionmapping {
        let obj = Object.assign(new TclItsmUserActionmapping(), model);
        TclItsmUserActionmapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TclItsmUserActionmapping>): TclItsmUserActionmapping {
        if (!model) return null;
        return TclItsmUserActionmapping.newInstance(<TclItsmUserActionmapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TclItsmUserActionmapping) {
        if (!obj) return;

        models.TclItsmUserActionmapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TclItsmUserActionmapping): boolean {
        Object.setPrototypeOf(obj, TclItsmUserActionmapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Corestack action for user management
     */
    corestack_action: string;

    /**
     * TCL ITSM action for user management
     */
    tcl_itsm_action: string;

    /**
     * Source for TCL ITSM user action
     */
    source: models.TclItsmUserActionEntity;

    /**
     * Target for TCL ITSM user action
     */
    target: models.TclItsmUserActionEntity;

}
